import React from 'react';
import { secondsToMinutes } from 'date-fns';

import type { IGigComplianceRow } from '@/components/agent/gig-compliance/types';

import { RowCell } from '@/components/agent/gig-compliance/ComplianceTable.styles';
import { isValidDeviationCell } from '@/helpers';

interface IProps {
  displayInMinutes?: boolean;
  row: IGigComplianceRow;
  rowKey: Extract<
    keyof IGigComplianceRow,
    'lateLogin10Minus' | 'lateLogin10Plus' | 'lateAvg' | 'earlyLogout10Minus' | 'earlyLogout10Plus' | 'earlyAvg'
  >;
}

const DeviationCell = ({ displayInMinutes, row, rowKey }: IProps): React.ReactElement => {
  const value = Number(row[rowKey]?.value);

  if (isValidDeviationCell(value, displayInMinutes) === false) {
    return <RowCell />;
  }

  return (
    <RowCell className={row[rowKey]?.isWarning && row.isPublished ? 'warning' : ''}>
      {row.isPublished ? (displayInMinutes ? `${secondsToMinutes(value)}m` : value) : ''}
    </RowCell>
  );
};

export { DeviationCell };
